import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-web",
  "use": "icon-soc-l1-mall-web-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-web\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 224h640v576H192V224zm64 64v448h512V288H256zm96 64h320v48H352v-48zm0 96h320v48H352v-48zm0 96h224v48H352v-48z\" />\r\n  <path d=\"M704 192h64v64h-64V192z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-web.svg
// module id = TosZ
// module chunks = 534